<template>
    <a-drawer
        :title="id === 0 ? 'Añadir nuevo precio' : 'Editar precio #' + id"
        :width="420"
        :visible="visible"
        :wrap-style="{ height: '100%', overflow: 'auto', paddingBottom: '108px' }"
        class="flex-1"
        @close="$emit('close')"
    >
        <validation-observer v-slot="{ passes, invalid }">
            <form
                :id="id"
                :app="app"
                :view="view"
                :fields="fields"
                @submit="passes(save)"
                @cancel="$emit('close')"
            >
                <div class="row">
                    <div class="col-12">
                        <g-field
                            v-model="fields.article"
                            :app="app"
                            :item="id"
                            type="relation"
                            table="articles"
                            column-search="name"
                            name="name"
                            ret-key="code"
                            ret-label="name"
                            placeholder="Articulo"
                            :clean="true"
                        />
                    </div>
                    <div class="col-12">
                        <g-field
                            v-model="fields.rate"
                            :app="app"
                            :item="id"
                            table="rates"
                            column-search="text"
                            name="rate"
                            placeholder="Tarifa"
                            :clean="true"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.pvp"
                            :app="app"
                            :item="id"
                            name="pvp"
                            title="PVP"
                        />
                    </div>
                    <div class="col">
                        <g-field
                            v-model="fields.pvd"
                            :app="app"
                            :item="id"
                            name="pvd"
                            title="PVD"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.discount"
                            :app="app"
                            :item="id"
                            name="discount"
                            title="Descuento"
                        />
                    </div>
                </div>

                <div
                    :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        padding: '10px 16px',
                        textAlign: 'right'
                    }"
                >
                    <a-button
                        :style="{ marginRight: '8px' }"
                        @click="$emit('close')"
                    >
                        Cancelar
                    </a-button>
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="loading"
                        :disabled="invalid"
                    >
                        {{ id === 0 ? 'Añadir' : 'Modificar' }}
                    </a-button>
                </div>
            </form>
        </validation-observer>
    </a-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: null
        }
    },
    data() {
        window.ratesForm = this
        return {
            view: 'ratePricesList',
            app: 'prices',
            loading: false,
            fields: {
                article: null,
                rate: null,
                pvp: 0,
                pvd: 0,
                discount: 0
            }
        };
    },
    methods: {
        async save() {
            this.loading = true;

            const params = {
                ...this.fields,
                article: this.fields.article ? this.fields.article.key : null,
                rate: this.fields.rate ? this.fields.rate.key : null
            };

            let data;
            if (this.id > 0) {
                data = await this.$gestios.items('prices').edit({ id: this.id, params });
            } else {
                data = await this.$gestios.items('prices').add({ params, view: this.view });
            }

            if (data.ok) this.$emit('close');

            this.loading = false;
        }
    }
};
</script>

<style>
</style>
